import React from 'react';
import './Footer.css';
import footerlogo from './assets/footerlogo.png'; 
const Footer = () => {
  const isMobile = window.innerWidth < 480;
  const currentYear = new Date().getFullYear();
  return (
    <footer>
     <div className="footer-container">
     <h4>Copyright © {currentYear} Ram Thanganagai Maligai {isMobile && <br />}| Powered by{' '}
          <a
            href="https://thofatechnologies.com/" 
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#F50052', textDecoration: 'none', marginRight: '5px' }}
          >
            Thofa
          </a>
          <a
            href="https://thofatechnologies.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#07A048', textDecoration: 'none' }}
          >
            Technologies </a> {isMobile && <br />}  </h4>
       <h4 className="powered-by">
       <span style={{ marginRight: '10px' }}>Privacy Policy</span> | 
           <span style={{ marginLeft: '10px' }}>Terms and Conditions</span>
        </h4>
      </div>  
    </footer>   
  );
}
export default Footer;
